import { css } from "@emotion/react"

type Props = {
  children: React.ReactNode
  gap?: number
}

const AlignCenterHorizontally = ({ children, gap }: Props) => {
  return (
    <div css={styles.container} style={{ rowGap: gap }}>
      {children}
    </div>
  )
}

export default AlignCenterHorizontally

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
}
